import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=fe8d12d0&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=fe8d12d0&prod&lang=scss&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=fe8d12d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8d12d0",
  null
  
)

export default component.exports